import React, { useContext, useEffect, useState } from "react";
import Title from "../Title/Title";
import overviewCards from "../Overview/OverviewCard/OverviewDummy";
import Info from "../Info/Info";
import { FlinkContext } from "../../context/FlinkContext";
import Loading from "../Loading/Loading";
import PrintedtMix from "./PrintedtMix";
import Logger from "../../Helper/Logger";

function FlinkElectricity() {
  const mixData = useContext(FlinkContext);
  const [mix, setMix] = useState(null);
  useEffect(() => {
    setMix(mixData.mix);
  }, [mixData]);

  return (
    <div id="currency" className="GrayBox">
      {mix ? (
        <Logger op="Chart" id="17151" className="Flink-container">
          <div className="mb-print-5">
            <Title
              title="Electricity Generation mix"
              icon={overviewCards.electricity.icon}
            />
          </div>
          <PrintedtMix
            data={mix.electricityChart}
            colors={[
              "#004474",
              "#70cff9",
              "#767D84",
              "#FFD600",
              "#12C182",
              "#0079CE",
              "#65C800",
              "#F3E5AB",
            ]}
          />
          <Info dayPeak={mix.daypeak} />
        </Logger>
      ) : (
        <Loading />
      )}
    </div>
  );
}

export default FlinkElectricity;
